import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/cyCrkManage',
    meta: { title: '出入库管理' },
    component: Layout,
    redirect: '/cyCrkManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '出入库管理', activeMenu: '/cyCrkManage' },
        component: () => import('@/views/cyCrkManage/CyCrkManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '详情', activeMenu: '/cyCrkManage' },
        component: () => import('@/views/cyCrkManage/CyCrkManageDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑', activeMenu: '/cyCrkManage' },
        component: () => import('@/views/cyCrkManage/CyCrkManageAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增', activeMenu: '/cyCrkManage' },
        component: () => import('@/views/cyCrkManage/CyCrkManageAdd.vue')
      },
      {
        path: 'approval',
        meta: { title: '审批', activeMenu: '/cyCrkManage' },
        component: () => import('@/views/cyCrkManage/CyCrkManageAdd.vue')
      }

    ]
  }

]
